export default "__VITE_ASSET__Cmnm47qX__"